import React from 'react';
import {observer} from 'mobx-react';
import {NewLiveCasinoConfiguration} from '../../../services/configurations/config-data-sections/arenas.configuration';
import {TopImageComponent} from '../../top-image/top-image.component';
import {SeoBreadCrumbsComponent} from '../seo-bread-crumbs/seo-bread-crumbs.component';
import {LiveCasinoArenaNavbar} from "./live-casino-arena-navbar/live-casino-arena-navbar.component";
import {LiveCasinoArenaGrid} from "./live-casino-arena-grid/live-casino-arena-grid.component";
import {OrbitComponentWithState} from '../../base-components/orbit-component-with-state/orbit-component-with-state';
import {IStickyHandler} from "../../sticky-handler/sticky-handler.interface";
import {LiveCasinoArenaNavbarButton} from "./live-casino-arena-navbar/live-casino-arena-navbar-button.component";
import { LiveArenaWidgetComponent } from '../../live-casino-widget/live-arena-widget.component';
import { LIVE_CASINO_PAGE_WRAPPER } from '../../../themes/css-global-classes';
import {LinkToOfferComponent} from "../../link-to-offer/link-to-offer.component";
import {DailyDealComponent} from "../../daily-deal/daily-deal.component";

export interface NewLiveCasinoArenaComponentProps {
  configs: NewLiveCasinoConfiguration;
  arenaName: string;
}

export interface INewLiveCasinoArenaComponentState {
}

const SEO_CATEGORY = 'LIVE_CASINO_NEW';

@observer
export class NewLiveCasinoArenaComponent extends OrbitComponentWithState<NewLiveCasinoArenaComponentProps, INewLiveCasinoArenaComponentState> {

    private _stickyHandler: IStickyHandler;
    private _topImageRef = React.createRef<HTMLDivElement>();

    componentDidMount() {
        super.componentDidMount();
        this.reaction(() => this.services.user.isAuthorized,
            () => this.services.liveTableFeeds.updateAiRecommendedLiveGames(),
            { fireImmediately: true }
        );
    }

    private get stickyHandler(): IStickyHandler {
        if(!this._stickyHandler && this._topImageRef?.current) {
            this._stickyHandler = this.services.stickyHandlerFactory.createStickyHandler();
        } else {
            return this.services.stickyHandlerFactory.createStickyHandler();
        }

        return this._stickyHandler;
    }

    private _renderLiveCasinoArenaNavbar(){
      if (this.props?.configs?.arenas?.length) {
        const categories = this.props.configs.arenas.filter(config => config.display);
        return <LiveCasinoArenaNavbar
          arenas={categories}
          stickyHandler={this.stickyHandler}
          FilterButtonComponent={LiveCasinoArenaNavbarButton}
        />
      }
    }

    private _renderLiveArenaWidget() {
        // this flag tell us if we expect to retrieve all live casino promotion from BR system
        // this is a configuration flag used not to harm CLS
        const isAllLiveGamesPromotion = this.services.partyJackpot.isAllLiveGamesPromotion;
        if (isAllLiveGamesPromotion) {
            //might return null if BR data was not retrieved yet
            const allLiveGamesPartyJackpot = this.services.partyJackpot.getAllLiveGamesJackpot();
            return <LiveArenaWidgetComponent partyJackpot={allLiveGamesPartyJackpot}/>;
        }
    }

    private _renderLinkToOffer() {
        return (
            <LinkToOfferComponent linkToOfferConfig={this.props.configs.linkToOffer}/>
        );
    }

    render() {
        return (
          <div className={`${LIVE_CASINO_PAGE_WRAPPER} cy-new-live-casino`}>

            <TopImageComponent image={this.props.configs.topImage} title={this.props.configs.title} topImageRef={this._topImageRef}/>

            {this._renderLiveCasinoArenaNavbar()}

            {this._renderLiveArenaWidget()}

              <LiveCasinoArenaGrid
                  seoCategory={SEO_CATEGORY}
                  tablesConfigs={this.props.configs}
                  promotionalBannerConfig={this.props.configs.promotionalBanner}
                  useAISortedList={this.props.configs.useAISortedList}/>

            <SeoBreadCrumbsComponent arenaName={this.props.arenaName} config={this.props.configs.seoSection}/>

            {this._renderLinkToOffer()}
            <DailyDealComponent />
          </div>
        );
    }
}
